import { createSlice } from '@reduxjs/toolkit';

import type { OAuth2Token } from './types';

export const slice = createSlice({
    initialState: {
        eaVisionToken: null as OAuth2Token | null
    },

    name: 'useEaVision',

    reducers: {
        eaVisionToken: (state, action) => {
            state.eaVisionToken = action.payload;
        }
    }
});

export default slice.reducer;
